module.exports = __webpack_public_path__ + "img/bell-off-03.8bb27f09.svg";